module.exports = __webpack_public_path__ + "static/media/7.828cd40a.png";